import type { SearchParams } from '@app/types/search.type'

/**
 * Transform search params to ready to append string for API calls
 * @param searchParams
 * @returns string with ?
 */
export const searchParamsToQuery = (searchParams: SearchParams) => {
	const search = new URLSearchParams()
	Object.keys(searchParams)
		.filter((key) => searchParams[key] !== null && searchParams[key] !== undefined && searchParams[key] !== '')
		.map((key) => search.append(key, searchParams[key]!.toString()))
	const query = search.toString()
	return query ? `?${query}` : ``
}
